const IS_OPEN_CLASSNAME = "is-open";

class Drawer {
    constructor({
        open: openSelector,
        close: closeSelector,
        drawer: drawerSelector,
        showOverlay = true
    }) {
        this.isOpen = false;

        this.openElement = document.querySelector(openSelector);
        this.closeElement = document.querySelector(closeSelector);
        this.drawerElement = document.querySelector(drawerSelector);

        this.attach();

        if (showOverlay) {
            this.renderOverlay();
        }
        this.render();
    }

    attach() {
        if (this.openElement) {
            this.openElement.addEventListener("click", () => {
                this.open();
                this.dispatchEvent("drawer.open");
            });
        }

        if (this.closeElement) {
            this.closeElement.addEventListener("click", () => {
                this.close();
                this.dispatchEvent("drawer.close");
            });
        }
    }

    dispatchEvent(event) {
        if (this.drawerElement) {
            this.drawerElement.dispatchEvent(new CustomEvent(event));
        }
    }

    open() {
        this.isOpen = true;
        this.render();
    }

    close() {
        this.isOpen = false;
        this.render();
    }

    renderOverlay() {
        const overlayElement = document.createElement("div");

        if (this.drawerElement) {
            const { overlayClassname = "" } = this.drawerElement.dataset;
            overlayElement.classList.add(
                ...["overlay", "drawer-overlay", ...overlayClassname.split(" ")]
            );
            overlayElement.dataset.overlay = "drawer";
            document.body.insertAdjacentElement("beforeend", overlayElement);
            this.overlayElement = overlayElement;
        }
    }

    render() {
        if (this.drawerElement) {
            if (this.isOpen) {
                this.drawerElement.classList.add(IS_OPEN_CLASSNAME);
            } else {
                this.drawerElement.classList.remove(IS_OPEN_CLASSNAME);
            }
        }

        if (this.overlayElement) {
            if (this.isOpen) {
                this.overlayElement.style.height = `${document.body.clientHeight}px`;
                this.overlayElement.classList.add(IS_OPEN_CLASSNAME);
            } else {
                this.overlayElement.classList.remove(IS_OPEN_CLASSNAME);
            }
        }
    }
}

export { Drawer };
